import { AppTable } from 'shared/UI/UIKit/Table';
import { AppPagination } from 'shared/UI/UIKit/Pagination';
import { itemRender, showTotal } from 'shared/UI/UIKit/Pagination/Pagination.utils';
import type { AppTableColumn, AppTableOnChange, AppTableState } from 'shared/UI/UIKit/Table';
import type { TeacherWorkloadsTableRow } from '../model/types';
import styles from './styles.module.scss';

type TeacherWorkloadsTableProps = {
  loading: boolean;
  dataSource: TeacherWorkloadsTableRow[];
  columns: AppTableColumn<TeacherWorkloadsTableRow>[];
  onChange: AppTableOnChange;
  tableState: AppTableState;
  pageSize: number;
  onPaginationChange: (page: number, pageSize: number) => void;
};

export const TeacherWorkloadsTable = ({
  loading,
  dataSource,
  columns,
  onChange,
  tableState,
  pageSize,
  onPaginationChange,
}: TeacherWorkloadsTableProps) => {
  return (
    <>
      <AppTable
        columns={columns}
        dataSource={dataSource}
        rowKey={(record) => record.key}
        loading={loading}
        paginationVisible={false}
        sorters={tableState.sorters}
        onChange={onChange}
        scroll={{ x: 'max-content' }}
        className={styles.table}
      />
      <AppPagination
        className="ant-table-pagination ant-table-pagination-right"
        current={tableState.pagination.current}
        total={tableState.pagination.total}
        pageSize={pageSize}
        pageSizeOptions={tableState.pagination.pageSizeOptions}
        hideOnSinglePage={false}
        showTotal={showTotal}
        itemRender={itemRender}
        showSizeChanger
        onChange={onPaginationChange}
        onShowSizeChange={onPaginationChange}
      />
    </>
  );
};
